import { useEffect, useState } from 'react';

// Keep in sync with the `$breakpoints-up` map in style/variables.scss.
export const breakpoints = {
  sm: 479,
  md: 767,
  lg: 991,
  xl: 1200,
  xxl: 1400,
  xxxl: 1480,
  ultra: 1920,
} as const;

export type Breakpoint = keyof typeof breakpoints;

export function useBreakpoints() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    isNarrowerThan: (size: Breakpoint) => width < breakpoints[size],
  };
}
